export default "__VITE_PUBLIC_ASSET__1e6739bb__"